export default __webpack_public_path__ + "static/media/shelfie-icon-rounded.ffcb0a05.png";